import { initComponent } from './core/init-component';

const FADE_MS = 200; // keep in sync with --duration-fast (0.2s)

initComponent('.js-ls-product-grid-section', (el) => {
  const tabs   = Array.from(el.querySelectorAll<HTMLElement>('[data-handle]'));
  const panels = Array.from(el.querySelectorAll<HTMLElement>('[data-panel]'));
  const cta    = el.querySelector<HTMLAnchorElement>('[data-cta] a');

  let fadeTimeout: number | undefined;

  function activate(handle: string) {
    // Tabs (underline + opacity) update instantly.
    tabs.forEach(tab => tab.setAttribute('aria-current', tab.dataset.handle === handle ? 'true' : 'false'));

    const current = panels.find(panel => !panel.hasAttribute('hidden'));
    const next    = panels.find(panel => panel.dataset.panel === handle);

    if (!next || next === current) return;

    if (cta && next.dataset.url) cta.href = next.dataset.url;

    const fadeIn = () => {
      next.style.opacity = '0';
      next.removeAttribute('hidden');
      // Two frames so the opacity:0 start is committed before transitioning to 1.
      requestAnimationFrame(() => requestAnimationFrame(() => {
        next.style.opacity = '1';
      }));
    };

    clearTimeout(fadeTimeout);

    if (current) {
      // Step 2: fade out the outgoing panel, then Step 3: fade in the new one.
      current.style.opacity = '0';
      fadeTimeout = window.setTimeout(() => {
        current.setAttribute('hidden', '');
        current.style.opacity = '';
        fadeIn();
      }, FADE_MS);
    } else {
      fadeIn();
    }
  }

  // With a single collection there's nothing to switch to, so let the tab's
  // native <a href> navigate straight to the collection PLP. We only intercept
  // clicks for tab-switching when there's more than one collection.
  if (tabs.length > 1) {
    tabs.forEach(tab => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        activate(tab.dataset.handle!);
      });
    });
  }

  return {
    unload: () => clearTimeout(fadeTimeout),
  };
});
